/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Sound_SuccessInputs */

const en_us2_workout_logging_sound_success = /** @type {(inputs: Workout_Logging_Sound_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Success`)
};

const pt_br2_workout_logging_sound_success = /** @type {(inputs: Workout_Logging_Sound_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sucesso`)
};

const es_419_workout_logging_sound_success = /** @type {(inputs: Workout_Logging_Sound_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éxito`)
};

const pt_pt2_workout_logging_sound_success = /** @type {(inputs: Workout_Logging_Sound_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sucesso`)
};

const fr_fr2_workout_logging_sound_success = /** @type {(inputs: Workout_Logging_Sound_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succès`)
};

const de_de2_workout_logging_sound_success = /** @type {(inputs: Workout_Logging_Sound_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfolg`)
};

const it_it2_workout_logging_sound_success = /** @type {(inputs: Workout_Logging_Sound_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successo`)
};

/**
* | output |
* | --- |
* | "Success" |
*
* @param {Workout_Logging_Sound_SuccessInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_sound_success = /** @type {((inputs?: Workout_Logging_Sound_SuccessInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Sound_SuccessInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_sound_success(inputs)
	if (locale === "es-419") return es_419_workout_logging_sound_success(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_sound_success(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_sound_success(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_sound_success(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_sound_success(inputs)
	return en_us2_workout_logging_sound_success(inputs)
});
export { workout_logging_sound_success as "workout-logging.sound_success" }